
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1598|8554)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
